import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Database, Info, Settings, ShieldCheck, UserRound } from "lucide-react";
import { NavLink } from "react-router-dom";
import { Button } from "./Button";

const menuItems = [
  { to: "/settings", label: "Settings", icon: Settings },
  { to: "/data", label: "Data", icon: Database },
  { to: "/safety", label: "Safety", icon: ShieldCheck },
  { to: "/about", label: "About", icon: Info },
];

export function UserMenu() {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Button
          aria-label="Open workspace menu"
          className="rounded-pill px-2"
          size="sm"
          variant="secondary"
        >
          <span className="flex h-6 w-6 items-center justify-center rounded-pill bg-ink-900 text-[0.6875rem] font-semibold text-white shadow-xs">
            CS
          </span>
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          className="dropdown-content z-50 min-w-56 rounded-card border border-border bg-surface-elevated p-1.5 shadow-[var(--shadow-key-2)]"
          sideOffset={8}
        >
          <div className="flex items-center gap-3 border-b border-border px-3 py-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-pill border border-border bg-surface-raised text-text-muted">
              <UserRound aria-hidden="true" className="h-4 w-4" strokeWidth={1.5} />
            </span>
            <div>
              <p className="text-sm font-semibold text-text">ClearScope</p>
              <p className="text-xs font-semibold text-text-subtle">Local workspace</p>
            </div>
          </div>
          {menuItems.map((item) => (
            <DropdownMenu.Item key={item.to} asChild>
              <NavLink
                className="flex min-h-10 items-center gap-3 rounded-sm px-3 py-2 text-sm font-semibold text-text outline-none transition hover:bg-surface-muted focus:bg-surface-muted"
                to={item.to}
              >
                <item.icon
                  aria-hidden="true"
                  className="h-4 w-4 text-text-subtle"
                  strokeWidth={1.5}
                />
                {item.label}
              </NavLink>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
